module.exports = __webpack_public_path__ + "static/media/dolphin-login.7eef0a1c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/dolphin-login.png
// module id = 341
// module chunks = 1